<template>
    <li :class="{active: isSelected}">
        <div v-if="price.on_request === 0" class="uk-grid-collapse tm-price" uk-grid>
            <div class="uk-width-expand" uk-leader>
                от {{ price.price_break }} шт.
            </div>
            <div class="tm-price-value">
                {{ price.calculated_price }} {{ currency.name }}
            </div>
        </div>
        <div v-else class="uk-grid-collapse tm-price" uk-grid>
            <div class="uk-width-expand" uk-leader>
                от {{ price.price_break }} шт.
            </div>
            <div class="tm-price-value">
                Цена по запросу
            </div>
        </div>

    </li>
</template>

<script>
    export default {
        name: "ProductPriceRow",
        props: {
            price: {
                type: Object,
                required: true,
            },
            currency: {
                type: Object,
                required: true,
            },
            type: {
                type: Object,
                required: true,
            },
            isSelected: {
                type: Boolean,
                default() {
                    return false
                }
            }
        }
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// ProductPriceRow.vue?6d631800